/**
 * 模块名称: 待结算列表 => 充值订单列表
 * @author jiashaowang@372163.com
 */

import React, { useState, useEffect } from 'react'
import api from '@/api'
import { Table, Button, Modal } from 'antd'
import { Link } from 'react-router-dom'
import { parseSearch, cryptoParamsIntoUrl } from '@/utils'
import CorpFilter from '@/components/CorpFilter'
import FiltersForm from '@/components/FiltersForm'
import PurchaseActionsForm from './components/PayActionsForm'
import '../assets/style.scss'

const PayStay = (props) => {
  const { match, location, history } = props
  const search = parseSearch(location.search)

  const initParams = {
    companyId: '',
    status: 3,
    page: search.page || 1,
    limit: search.limit || 10,
  }

  const [states, setStates] = useState({
    dataSource: [], // 列表
    loading: true,
    total: 0, // 总条数
    actions: {
      type: -1,
      values: {},
    },
    filter: {
      project: [], // 筛选：项目
      payTypes: [
        { id: 1, name: '银行转账' },
        { id: 2, name: '在线支付' },
        { id: 3, name: '信用金还款' },
      ], // 筛选：付款方式
      status: [
        { id: 3, name: '待付款' },
        { id: 5, name: '终止付款' },
      ], // 筛选：状态
    },
    // 筛选条件：列表接口参数
    params: initParams,
  })
  const { dataSource, actions, filter, loading, total, params } = states

  useEffect(() => {
    getList()
  }, [params])

  useEffect(() => {
    getTopProjectList(params.companyId)
  }, [params.companyId])

  // 获取列表
  const getList = () => {
    api
      .getTopUpWaitCloseList(params)
      .then((res) => {
        setStates((current) => ({
          ...current,
          loading: false,
          dataSource: res.list,
          total: res.count,
        }))
      })
      .catch(() => {
        setStates((current) => ({
          ...current,
          loading: false,
        }))
      })
  }

  // 获取项目
  const getTopProjectList = (id) => {
    api.getTopProjectList({ companyId: id }).then((data) => {
      setStates((current) => ({
        ...current,
        filter: {
          ...filter,
          project: data.list,
        },
      }))
    })
  }

  // 点击筛选
  const onSubmit = (values, type) => {
    initParams.page = 1
    initParams.limit = 10
    if (type!== 2) {
      delete initParams.status
    }
    setStates((current) => ({
      ...current,
      loading: true,
      params: {
        ...initParams,
        companyId: params.companyId,
        ...values,
      },
    }))
    history.replace(match.path)
  }

  // 点击选择所属公司
  const onChangeCorp = (data) => {
    setStates((current) => ({
      ...current,
      loading: true,
      params: {
        ...params,
        companyId: data.map((item) => item.id),
        page: 1,
      },
    }))
    history.replace(match.path)
  }

  // 分页点击
  const onChangeTable = (pagination, filters, sorter) => {
    const { current: page, pageSize: limit } = pagination
    setStates((current) => ({
      ...current,
      loading: true,
      params: {
        ...params,
        page: page,
        limit: limit,
      },
    }))
    history.replace(match.path + '?page=' + page + '&limit=' + limit)
  }

  // 操作：修改-0、结算-1、终止付款-2
  const onActions = (record, type) => {
    setStates((current) => ({
      ...current,
      actions: {
        type,
        values: record,
      },
    }))
  }

  const onActionsCancel = () => {
    setStates((current) => ({
      ...current,
      actions: { type: -1 },
    }))
  }

  const onActionsSubmit = (values, callback, type) => {
    callback(true)
    api[['setTopUpFinanceEdit', 'setTopUpClose', 'setTopUpFail'][type]](values)
      .then((res) => {
        onActionsCancel()
        getList()
      })
      .catch((err) => {
        callback(false)
        console.log(err)
      })
  }

  // 预览/下载凭证
  const onVoucherAction = (record, download = false) => {
    api.getHost({}).then((res) => {
      if (download) {
        window.location = `${res.url}/api/fortune/File/DownPdf?id=${record.id}&type=${'TopUpProof'}`
      } else {
        window.open(
          `${res.url}/api/fortune/File/PrevPdf?id=${record.id}&type=${'TopUpProof'}`,
          '_blank'
        )
      }
    })
  }

  const columns = [
    {
      title: '业务编号',
      dataIndex: 'id',
      fixed: 'left',
      valueType: 'Input',
      fieldProps: {
        placeholder: '请输入业务编号',
      },
    },
    {
      title: '项目',
      dataIndex: 'projectId',
      valueType: 'Select',
      fieldProps: {
        placeholder: '全部',
        showSearch: true,
        optionFilterProp: 'children',
        options: filter.project.map((item) => ({
          label: item.name,
          value: item.id,
        })),
      },
      render: (text, record) => record.projectName,
    },
    { title: '产品', dataIndex: 'productName' },
    { title: '公司主体', dataIndex: 'companyName' },
    { 
      title: '充值金额', 
      dataIndex: 'money',
      valueType: 'Input',
      fieldProps: {
        placeholder: '请输入充值金额',
      }, 
    },
    { 
      title: '收款单位', 
      dataIndex: 'payee',
      valueType: 'Input',
      fieldProps: {
        placeholder: '请输入收款单位',
      },
    },
    { title: '开户行', dataIndex: 'openBank' },
    { title: '银行账号', dataIndex: 'bankNumber' },
    {
      title: '付款方式',
      dataIndex: 'payType',
      valueType: 'Select',
      fieldProps: {
        placeholder: '全部',
        showSearch: true,
        options: filter.payTypes.map((item) => ({
          label: item.name,
          value: item.id,
        })),
      },
      render: (text, record) => record.payTypeName,
    },
    {
      title: '状态',
      dataIndex: 'status',
      valueType: 'Select',
      fieldProps: {
        placeholder: '全部',
        showSearch: true,
        options: filter.status.map((item) => ({
          label: item.name,
          value: item.id,
        })),
      },
      render: (text, record) => record.statusName,
    },
    {
      title: '申请人',
      dataIndex: 'applyStafName',
      valueType: 'Input',
      fieldProps: {
        placeholder: '请输入申请人',
      },
    },
    {
      title: '申请时间',
      dataIndex: 'createTime',
      valueType: 'RangePicker',
      search: {
        transform: (value) => {
          return {
            applyStart: value[0].format('YYYY-MM-DD'),
            applyEnd: value[1].format('YYYY-MM-DD'),
          }
        },
      },
    },
    {
      title: '审批通过时间',
      dataIndex: 'auditTime',
      valueType: 'RangePicker',
      search: {
        transform: (value) => {
          return {
            auditStart: value[0].format('YYYY-MM-DD'),
            auditEnd: value[1].format('YYYY-MM-DD'),
          }
        },
      },
    },
    {
      title: '操作',
      dataIndex: 'oprate',
      fixed: 'right',
      width: 120,
      render: (text, record) => {
        return (
          <>
            <Link
              target='_blank'
              to={cryptoParamsIntoUrl('/supplie/topUp/detail', { id: record.id })}
            >
              <Button block type='link' size='small'>
                详情
              </Button>
            </Link>
            {record.status === 3 && (
              <>
                {record.hasClose && (
                  <Button
                    block
                    type='link'
                    size='small'
                    onClick={() => onActions(record, 1)}
                  >
                    支付
                  </Button>
                )}
                {record.hasFail && (
                  <Button
                    block
                    type='link'
                    size='small'
                    onClick={() => onActions(record, 2)}
                  >
                    终止付款
                  </Button>
                )}
              </>
            )}
            {record.hasPrev ?
              <Button
                block
                type='link'
                size='small'
                onClick={() => onVoucherAction(record)}
              >
                凭证预览
             </Button> : null
            }
            {record.hasDown ?
              <Button
                  block
                  type='link'
                  size='small'
                  onClick={() => onVoucherAction(record, true)}
                >
                  下载凭证
              </Button> : null
            }
          </>
        )
      },
    },
  ]
  return (
    <>
      <CorpFilter onChange={onChangeCorp}/>
      <FiltersForm columns={columns} initialValues={{ status: 3 }} onSubmit={onSubmit} onReset={(val) => onSubmit(val, 2)} />
      <div className='line'></div>
      <div className='add-wrap'></div>
      <Table
        size='small'
        columns={columns}
        dataSource={dataSource}
        rowKey='id'
        loading={loading}
        pagination={{
          pageSize: parseInt(params.limit),
          total: total,
          current: parseInt(params.page),
          showQuickJumper: true,
          showSizeChanger: true,
          pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
        }}
        onChange={onChangeTable}
        scroll={{ x: 2000 }}
      ></Table>
      <Modal
        title={['收款方信息修改', '支付确认', '终止付款确认'][actions.type]}
        visible={actions.type >= 0}
        closable={false}
        destroyOnClose={true}
        maskClosable={false}
        footer={null}
      >
        <PurchaseActionsForm
          type={actions.type}
          values={actions.values}
          onSubmit={(values, callback) =>
            onActionsSubmit(values, callback, actions.type)
          }
          onCancel={onActionsCancel}
        />
      </Modal>
    </>
  )
}

export default PayStay
